export enum CMBLandingPageSources {
  PDP_TOP_WIDGET = 'pdp_top_widget',
}
